import api from "./api";
import StorageService from "./StorageService";

const StoreService = {
  getAll: async (page = 1, limit = 20, companyId = null, employeeId = null, roleId = null) => {
    const login = StorageService.loginData();
    const activeCompany = StorageService.activeCompany();
    const res = await api.get("/projectStore/getAll", {
      params: {
         page,
         limit,
         companyId: companyId || activeCompany?.companyId,
         employeeId: employeeId || login?.employeeId,
         roleId: roleId || login?.roleId,
      },
    });
    return res.data;
  },

  create: async (data) => {
    const res = await api.post("/projectStore/save", data);
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/projectStore/getById/${id}`);
    return res.data.data;
  },

  getProjectStoreById: async (projectId) => {
    const res = await api.get(`/projectStore/getProjectStoreById/${projectId}`);
    return res.data;
  },
  update: async (id, data) => {
    const res = await api.put(`/projectStore/update/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/projectStore/${id}`);
    return res.data;
  },

  updateStatus: async (id) => {
    const res = await api.put(`/projectStore/updateStatus/${id}`);
    return res.data;
  },

  getActive: async () => {
    const res = await api.get("/projectStore/active");
    return res.data;
  },
};

export default StoreService;
